import * as R from 'ramda';

export const mapApplicationSummaryFromJson = R.compose(json => {
  return {
    total_active_loan: R.defaultTo("-", json['active_loan']),
    total_complete_loan: R.defaultTo("-", json['complete_loan']),
    pending_loan_count: R.defaultTo("-", json['total_pending_loans']),
    pending_loan_amount: R.defaultTo("-", json['total_pending_loans_amount'])
  }
}, R.defaultTo({}))


export const mapApplicationFromJson = R.compose(json => {
  return {
    application_id: R.defaultTo("-", json['application_id']),
    lender_id: R.defaultTo("-", json['lender_id']),
    borrower_user_id: R.defaultTo("-", json['borrower_user_id']),
    loan_id: R.defaultTo("-", json['loan_id']),
    product: R.defaultTo("-", json['product']),
    loan_amount: R.defaultTo("-", json['loan_amount']),
    service_fee: R.defaultTo("-", json['pricing']['service_fee']),
    emi_rate: R.defaultTo("-", json['pricing']['emi_rate']),
    late_fee: R.defaultTo("-", json['pricing']['late_fee']),
    penalty: R.defaultTo("-", json['pricing']['penalty']),
    tenure: R.defaultTo("-", json['pricing']['tenure']),
    interest: R.defaultTo("-", json['pricing']['interest']),
    mdr: R.defaultTo("-", json['pricing']['mdr']),
    admin_fee: R.defaultTo("-", json['pricing']['admin_fee']),
    paired_at: R.defaultTo("-", json['paired_at']),
    status: R.defaultTo("-", json['status']),
    confirmed_at: R.defaultTo("-", json['confirmed_at']),
    disbursed_amount: R.defaultTo("-", json['disbursed_amount']),
    disbursed_at: R.defaultTo("-", json['disbursed_at']),
    expired_at: R.defaultTo("-", json['expired_at']),
    nik: R.defaultTo("-", json['nik']),
    monthly_income: R.defaultTo("-", json['monthly_income']),
    pefindo_collectability: R.defaultTo("-", json['pefindo_collectability']),
    pefindo_worst_dpd: R.defaultTo("-", json['pefindo_worst_dpd']),
    pefindo_score: R.defaultTo("-", json['pefindo_score']),
    a_score: R.defaultTo("-", json['ascore']),
    partner: R.defaultTo("-", json['partner']),
    segmentation: R.defaultTo("-", json['segmentation']),
    loan_type: R.defaultTo("-", json['loan_type']),
    submission_date: R.defaultTo("-", json['submission_date']),
    expiration_date: R.defaultTo("-", json['expiration_date']),
    outstanding: R.defaultTo("-", json['outstanding']),
    days_past_due: R.defaultTo("-", json['days_past_due']),
    dpd_amount: R.defaultTo("-", json['dpd_amount']),
    // tenure: R.defaultTo("-", json['tenure']),
    mdr: R.defaultTo("-", json['mdr']),
    borrower_name: R.defaultTo("-", json['borrower_name']),
    purpose: R.defaultTo("-", json['purpose']),
    ofin_credit_score: R.defaultTo("-", json['ofin_credit_score']),
  };
}, R.defaultTo({}));